module.exports = new __parcel__URL__("gba_dark.8c260f8d.png").toString();